import { Layout } from "antd";
import { Outlet } from "react-router-dom";

import { TopNavBar } from "../../../components/navigations/top-nav-bar/TopNavBar.jsx";

function ReviewLayout() {
  return (
    <div className="landingPage">
      <TopNavBar />
      <Layout>
        <Outlet />
      </Layout>
    </div>
  );
}

export { ReviewLayout };
